import { useCallback, useEffect, useState } from 'react';

const InfiniteScroll = (props: any) => {
    const { targetId, isDataLoading, currentRecordCount, totalRecordCount, fetchNext } = props;
    let target: HTMLElement | null = null;
    const [isInfiniteScrollActive, setIsInfiniteScrollActive] = useState<boolean>(false);
    const [scrollPosition, setScrollPosition] = useState<number>(0);

    const handleScroll = useCallback(() => {
        if (target) {
            const scrollTop = target.scrollTop;
            const offsetHeight = target.clientHeight;
            const scrollHeight = target.scrollHeight;

            if (
                scrollTop &&
                offsetHeight &&
                scrollHeight &&
                scrollHeight - (scrollTop + offsetHeight) <= 10 &&
                currentRecordCount < totalRecordCount &&
                !isDataLoading
            ) {
                setIsInfiniteScrollActive(true);
            }
            if (!isDataLoading && !isInfiniteScrollActive && scrollTop) {
                setScrollPosition(scrollTop);
            }
        }
    }, [isDataLoading]);

    useEffect(() => {
        target = document.getElementById(targetId);
        target && target.addEventListener('scroll', handleScroll);
        // return () => target && target.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    useEffect(() => {
        if (isInfiniteScrollActive && !isDataLoading) {
            fetchNext();
            setIsInfiniteScrollActive(false);
        } else if (target) {
            target.scrollTop = scrollPosition;
        }
    }, [isInfiniteScrollActive, isDataLoading]);
    return null;
};
export default InfiniteScroll;
